/**
 * 認証用Service Workerの管理
 */

let swRegistration: ServiceWorkerRegistration | null = null

/**
 * 認証用Service Workerを登録
 */
export const registerAuthServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
  if (!('serviceWorker' in navigator)) {
    console.warn('[Auth SW] Service Worker is not supported')
    return null
  }

  try {
    // 既存の登録を確認
    const existingReg = await navigator.serviceWorker.getRegistration('/auth-sw.js')
    if (existingReg) {
      swRegistration = existingReg
      console.log('[Auth SW] Using existing registration')
      return existingReg
    }

    // 新規登録
    swRegistration = await navigator.serviceWorker.register('/auth-sw.js', {
      scope: '/',
    })

    console.log('[Auth SW] Registered successfully')
    return swRegistration
  } catch (error) {
    console.error('[Auth SW] Registration failed:', error)
    return null
  }
}

/**
 * Service Workerにトークンを送信
 */
export const updateAuthToken = (token: string | null): void => {
  // アクティブなService Workerに送信
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SET_AUTH_TOKEN',
      token,
    })
  }

  // 登録済みのService Workerにも送信（アクティベート待ちの場合）
  if (swRegistration?.active) {
    swRegistration.active.postMessage({
      type: 'SET_AUTH_TOKEN',
      token,
    })
  }
}

/**
 * Service Workerの準備完了を待つ
 */
export const waitForServiceWorker = async (): Promise<ServiceWorkerRegistration> => {
  return navigator.serviceWorker.ready
}
